import './CreateMenuLink.scss';

import React from 'react';

import Icon from 'components/Icon';

export default class CreateMenuLink extends React.Component {
    static propTypes = {
        icon: React.PropTypes.string.isRequired,
        onClick: React.PropTypes.func.isRequired
    };

    render() {
        let { icon, onClick } = this.props;
        return (
            <div role="button" onClick={onClick.bind(this)} className="create-menu__link">
                <div className="create-menu__icon">
                    <Icon icon={icon} />
                </div>
                {this.props.children}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/CreateMenu/CreateMenuLink/index.js